import React, { Component } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import NoData from "../Dashboard/Charts/NoData/NoData";
import { numberWithCommas, kmFormatter } from "../Dashboard/Charts/utils";
import HighchartsCustomEvents from "highcharts-custom-events";

HighchartsCustomEvents(Highcharts);

const colors = {
    "13-17": "#8850CF",
    "18-24": "#038C37",
    "25-34": "#fbceb1",
    "35-44": "#ffbf00",
    "45-54": "#013e62",
    "55-64": "#BD0BBF",
    "65+": "#A83F4B",
};

class TotalAudienceByAge extends Component {
    constructor(props) {
        super(props);
        this.chartComponent = React.createRef();
        this.state = {
            rerender: 0,
        };
    }

    componentDidMount() {
        // if (!this.props.isFBPage) {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart?.setSize(null, null);
                this.chartComponent?.current?.chart?.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef?.current) {
            this.ro.observe(this.props.widgetContainerRef?.current);
        } else {
            this.setState({ rerender: this.state.rerender + 1 });
        }
        // }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.rerender) {
            if (this.props.widgetContainerRef?.current) {
                this.ro.observe(this.props.widgetContainerRef?.current);
                this.setState({ rerender: 0 });
            } else if (prevState.rerender !== this.state.rerender) {
                setTimeout(() => {
                    this.setState({ rerender: this.state.rerender + 1 });
                }, 100);
            }
        }
    }
    componentWillUnmount() {
        if (!this.props.isFBPage) {
            this.ro.disconnect();
        }
    }

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount && this.props.data && !this.props.data.nodata) {
    //         this.chartComponent.current?.chart?.setSize(null, null);
    //         this.chartComponent.current?.chart?.reflow();
    //     }
    // }

    formatAgeBarData(data) {
        if (!data) return;
        let res = [];
        let total = Object.values(data)
            .map((x) => x)
            .reduce((x, y) => x + y, 0);
        for (let age in data) {
            let ageName = age;
            let counts = data[age];
            let percentage = ((data[age] / total) * 100).toFixed(2);
            let color = colors[age];
            res.push({
                percent: percentage,
                color: color,
                counts: counts,
                name: ageName,
                totalVal: total,
                dataLabels: {
                    inside: false,
                    x: 10,
                },

                data: [{ name: ageName, y: counts, percent: percentage, totalVal: total }],
            });
        }
        res = res && res.sort((a, b) => b.counts - a.counts);
        return res;
    }

    formatAgePieData(data) {
        if (!data) return;
        let res = [];
        let total = Object.values(data)
            .map((x) => x)
            .reduce((x, y) => x + y, 0);
        for (let age in data) {
            let ageName = age;
            let counts = data[age];
            let percentage = ((data[age] / total) * 100).toFixed(2);
            let color = colors[age];
            res.push({
                y: counts,
                displayY: numberWithCommas(counts),
                color: color,
                name: ageName,
                percent: percentage,
                totalVal: total,
            });
        }
        res = res && res.sort((a, b) => b.y - a.y);
        return res;
    }

    getOptions = () => {
        if (this.props.graph_type == "pie" || this.props.graph_type == "line") return this.getPieOptions();
        else return this.getBarOptions();
    };

    getBarOptions = () => {
        const data = this.formatAgeBarData(this.props.data?.audienceByAge?.data);
        const height = this.props.isFBPage ? "338px" : null;
        const legendAlign = this.props.isFBPage ? "right" : "center";

        let self = this;
        const options = {
            chart: {
                type: "bar",
                spacingLeft: 10,
                spacingTop: 0,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                height: height,
            },
            title: {
                text: " ",
            },
            credits: {
                enabled: false,
            },

            xAxis: {
                type: "category",

                lineWidth: 1,
            },

            yAxis: {
                title: "",
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
            },
            legend: {
                enabled: this.props.showLegend,
                layout: "horizontal",
                align: legendAlign,
                alignColumns: true,
                padding: 3,
                itemMarginTop: 3,
                itemMarginBottom: 3,
                itemMarginLeft: 3,
                verticalAlign: "bottom",
                labelFormatter: function () {
                    return `<p>${this.name}</p><br/>`;
                },
            },

            series: data,
            plotOptions: {
                series: {
                    pointWidth: 15,
                    stacking: "normal",
                    events: {
                        legendItemClick: function () {
                            if (this.visible) {
                                this.setData([], false);
                            } else {
                                this.setData(data[this.index].data, false);
                            }
                        },
                    },
                },
                bar: {
                    dataLabels: {
                        inside: false,
                        enabled: this.props.showLabel,
                        formatter: function () {
                            return `<span><b>${kmFormatter(this.point.y)}</b></span>
                            `;
                        },
                        style: {
                            color: "#333333",
                        },
                    },
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                },
            },
            tooltip: {
                backgroundColor: "#fff",
                borderRadius: 6,
                formatter: function () {
                    return `<span>${this.point.name}</span> <br/> <span>Audience Count |  <b>${this.point.percent}% | </b>
                   <span> <b>${numberWithCommas(this.point.y)}</b> / <b>${numberWithCommas(this.point.totalVal)}</b></span>
                    </span>`;
                },
            },
        };

        return options;
    };

    getPieOptions = () => {
        const chartData = this.formatAgePieData(this.props.data?.audienceByAge?.data);
        const spacingTop = this.props.isFBPage ? 60 : 20;
        const height = this.props.isFBPage ? "60%" : null;
        const legendAlign = this.props.isFBPage ? "right" : "center";

        let self = this;

        let chartConfig = {
            chart: {
                type: "pie",
                className: "skiptranslate",
                backgroundColor: "transparent",
                spacingTop: spacingTop,
                spacingLeft: 0,
                spacingRight: 5,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                height: height,
            },
            title: {
                text: ``,
            },
            credits: {
                enabled: false,
            },
            plotOptions: {
                pie: {
                    shadow: false,
                    showInLegend: true,
                    dataLabels: {
                        enabled: this.props.showLabel,
                        distance: "10%",
                        //format: "{point.name}: {point.displayY}",
                        formatter: function () {
                            return `<span>${this.point.name}: </span> <span><b>${this.point.percent}%</b></span>
                            `;
                        },
                        style: {
                            fontWeight: 400,
                            color: "#333333",
                        },
                    },
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                },
            },
            legend: {
                enabled: this.props.showLegend,
                itemStyle: {
                    fontWeight: 400,
                },
                alignColumns: true,
                align: legendAlign,
                layout: "horizontal",
                verticalAlign: "bottom",
                padding: 0,
                itemMarginTop: 4,
                itemMarginBottom: 0,
                itemMarginLeft: 0,
            },
            xAxis: {
                lineWidth: 0,
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            series: [
                {
                    data: chartData,
                },
            ],
            tooltip: {
                backgroundColor: "#fff",
                borderRadius: 6,
                formatter: function () {
                    return `<span>${this.point.name}</span> <br/> <span>Audience Count |  <b>${this.point.percent}% | </b>
                   <span> <b>${numberWithCommas(this.point.y)}</b> / <b>${numberWithCommas(this.point.totalVal)}</b></span>
                    </span>`;
                },
            },
        };
        return chartConfig;
    };

    render() {
        return (
            <>
                {!this.props.isNoData() ? (
                    <>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getOptions()}
                            ref={this.chartComponent}
                            containerProps={!this.props.isFBPage && { style: { width: "100%", height: "calc(100% - 20px)" } }}
                        />
                    </>
                ) : (
                    <NoData message={this.props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />
                )}
            </>
        );
    }
}

export default TotalAudienceByAge;
